<div class="bg-color-base-3100 h-100vh text-align-center">
    <grid-row class="justify-content-center align-content-center h-600 pt-50">
        <grid-col col="6" class="h-100">
            <grid-row class="h-100 justify-content-center align-content-between">
                <grid-col col="12">
                    <ng-icon iconClass="icon-info-green-big" width="100" height="100"></ng-icon>
                </grid-col>
                <grid-col col="12">
                    <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3">
                        {{"YourAccountSuspended" | translate}}
                    </div>
                    <div class="font-400 font-size-16px color-base-700 line-h-22 mt-10 letter-spacing-1">
                        {{"YouExceededMaximum" | translate}}
                    </div>
                    <!-- <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3">
                        {{"YouRequestedLetter" | translate}}
                    </div>
                    <div class="font-400 font-size-16px color-base-700 line-h-22 mt-10 letter-spacing-1">
                        {{"RequestLetterAlreadyProcess" | translate}}
                    </div> -->
                  
                    <!-- <grid-row class="justify-content-center mt-40">
                        <grid-col col="12" mobile="11">
                            <grid-row class="align-content-center justify-content-between mt-15">
                                <grid-col col="auto">
                                    <div class="font-400 font-size-20px color-base-700">
                                        {{"RefID" | translate}}
                                    </div>
                                </grid-col>
                                <grid-col col="auto">
                                    <div class="font-500 font-size-20px color-base-700">
                                        890403244322000
                                    </div>
                                </grid-col>
                            </grid-row>
                        </grid-col>
                    </grid-row> -->
                </grid-col>
                <grid-col col="12">
                    <grid-row class="justify-content-center">
                        <grid-col col="10" mobile="11">
                            <grid-row class="mt-30">
                                <grid-col col="12">
                                    <button class="btn-dft-border" [routerLink]="['/LoginWithIdNum']">
                                        {{ "LogOut" | translate }}
                                    </button>
                                    <!-- <button class="btn-dft-border">
                                        {{ "BACKTOHOME" | translate }}
                                    </button> -->
                                </grid-col>
                            </grid-row>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
        </grid-col>
    </grid-row>
</div>